import styled from 'styled-components';
import {
	Primary50, 
	Primary200, 
	Primary500,
	Grey600,
	Grey800,
} from '../../Colors';

export default{
	Tag : styled.span`
		border-radius : 1rem;
		background-color : ${Primary50};
        padding : 0.5rem;
		&:hover{
			background-color : ${Primary200};
		}
	`,
	RemoveButton : styled.button`
		max-width : 10rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border: 0;
		color : ${Primary500};
		background-color : transparent;
		text-decoration: none;
		text-transform: none;
		&:focus{
			border: 0;
			outline: 0;
		}
    `,
	MoveButton : styled.button`
		max-width : 10rem;
		overflow: hidden;
		cursor : default;
        text-overflow: ellipsis;
        padding-left : 0;
		white-space: nowrap;
		border: 0;
		color : ${Primary500};
		background-color : transparent;
		text-decoration: none;
		text-transform: none;
		&:focus{
			border: 0;
			outline: 0;
		}
	`,
	ReadOnlyTag : {
		Wrapper : styled.span`
			cursor : pointer;
			padding : 1px;
			color : ${Grey600};
			&:hover{
				color : ${Grey800};
			}
		`,
		TextWrapper : styled.span`
			margin-left : 0.5rem;
		`
	}
};

